import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

const RATIO = 1.829;

export default withIconWrapper(function Ticket({ color, size = 24, outline = false, ...props }) {
  if (outline) {
    const outlineRatio = 64 / 38;
    return (
      <Svg fill="none" height={size} viewBox="0 0 64 38" width={size * outlineRatio} {...props}>
        <Path
          d="M62.764 36.395H.625V26.01a7.211 7.211 0 0 0 5.123-2.135 7.211 7.211 0 0 0 2.126-5.123 7.258 7.258 0 0 0-7.249-7.249V.625h62.139V11.52c-.162 0-.332-.017-.508-.017a7.252 7.252 0 0 0 0 14.501c.167 0 .337 0 .508-.017v10.408Z"
          fill="#fff"
          stroke={color || '#E51937'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </Svg>
    );
  }

  return (
    <Svg fill={color} height={size} viewBox="0 0 74.663 40.835" width={size * RATIO} {...props}>
      <Path d="M73.663 40.835H1a1 1 0 01-1-1V27.223a7.238 7.238 0 005.029-2 6.613 6.613 0 002.086-4.809A6.974 6.974 0 000 13.612V1a1 1 0 011-1h72.663a1 1 0 011 1v12.612a6.973 6.973 0 00-7.115 6.806 6.973 6.973 0 007.115 6.806v12.611a1 1 0 01-1 1z" />
    </Svg>
  );
});
